import { useEffect, useRef, useState } from "react";
import CreateNewDefinitionLookupFields from "./CreateNewDefinitionLookupFields";
import CreateNewDefinitionRowFiltering from "./CreateNewDefinitionRowFiltering";
import { useSelector } from "react-redux";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { Paper } from "@mui/material";

const CreateNewDefinition = ({ onRegisterForceRefresh }: any) => {
  const { loading } = useSelector((state: any) => state.uniqueDefinition);
  const [showLookupFields, setShowLookupFields] = useState(false);
  const lookupRef = useRef<any>(null);
  const rowFilteringRef = useRef<any>(null);

  useEffect(() => {
    onRegisterForceRefresh(() => async () => {
      const filteringPayload = rowFilteringRef.current?.refresh() ?? null;
      const lookupPayload = lookupRef.current?.refresh() ?? null;

      return {
        filteringPayload,
        lookupPayload,
      };
    });
  }, [onRegisterForceRefresh]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <>
            <Paper style={{ margin: "15px" }}>
              <CreateNewDefinitionRowFiltering
                setShowLookupFields={setShowLookupFields}
                ref={rowFilteringRef}
              />
            </Paper>
            <Paper style={{ margin: "15px" }}>
              {showLookupFields && (
                <CreateNewDefinitionLookupFields ref={lookupRef} />
              )}
            </Paper>
          </>
          {/* <Typography
            variant="body2"
            sx={{ mt: 3, textAlign: "center", color: "#888" }}
          >
            No data found for the selected interface and destination table.
          </Typography> */}
        </>
      )}
    </>
  );
};

export default CreateNewDefinition;
